const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  value === "" ||
  (Array.isArray(value) && value.length === 0) ||
  (typeof value === "object" && Object.keys(value).length === 0);

const prune = (value) => {
  if (Array.isArray(value)) {
    return value.map(prune).filter((item) => !isEmpty(item));
  }

  if (value && typeof value === "object") {
    return Object.keys(value).reduce((result, key) => {
      const pruned = prune(value[key]);

      return isEmpty(pruned) ? result : { ...result, [key]: pruned };
    }, {});
  }

  return value;
};

// O texto vem do cadastro e vai para dentro de uma tag <script>: sem o escape,
// um "</script>" digitado pelo profissional fecharia a tag.
const LINE_SEPARATORS = new RegExp(
  `[${String.fromCharCode(0x2028)}${String.fromCharCode(0x2029)}]`,
  "g"
);

const serializeJsonLd = (data) =>
  JSON.stringify(prune(data))
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(
      LINE_SEPARATORS,
      (char) => `\\u${char.charCodeAt(0).toString(16)}`
    );

module.exports = serializeJsonLd;
